import { type FC } from "react";
import { StyledRectangleContainer, StyledContainer } from "./styled";

const FourHorizontalCardsBlockPlaceholder: FC = () => {
  return (
    <StyledContainer>
      <Rectangle />
      <Rectangle />
      <Rectangle />
      <Rectangle />
    </StyledContainer>
  );
};

const Rectangle: FC = () => {
  return <StyledRectangleContainer />;
};

export default FourHorizontalCardsBlockPlaceholder;
